export var tokens = {
    '#': { pattern: /\d/ },
    '@': { pattern: /[A-Za-z]/ },
    '*': { pattern: /[\dA-Za-z]/ }
};
